<template>
  <OrderTemplate
    :custom-page="customPage"
    page-type="edit"
  />
</template>

<script setup>
import { OrderTemplate } from '../../OrderTemplate/'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
const { t } = useI18n()

const customPage = computed(() => ({
  headerTitle: t('orderEdit.title'),
  buttonText: t('common.save'),
}))
</script>
